// extracted by mini-css-extract-plugin
export default {"copy":"Copy_copy__+Ck0N","--light":"Copy_--light__4+HhO","--dark":"Copy_--dark__ebGOo","fadeIn":"Copy_fadeIn__kZkYU","hoverLineLink":"Copy_hoverLineLink__uidw0"};